import { firebaseAuth, db } from '../firebase'

export function userListener(email, pw) {
    return dispatch => {
        firebaseAuth().onAuthStateChanged(user => {
            if (user) {
                dispatch({type: "LOGIN_STATE_CHANGED", payload: {auth:true, data:user}})
            } else {
                dispatch({type: "LOGIN_STATE_CHANGED", payload: {auth:false, data:null}})
            }
          })

    }
}

export function login(email, pw) {
    return dispatch => {
        firebaseAuth().signInWithEmailAndPassword(email, pw).then(data=>{
            dispatch({type: "USER_LOGIN_FULFILLED", payload: data})
        }).catch(error=>{
            dispatch({type: "USER_LOGIN_REJECTED", payload: error})
        })

    }
}

export function logout() {
    return dispatch => {
        firebaseAuth().signOut().then(()=>{
            dispatch({type: "USER_LOGOUT_FULFILLED", payload: 'success'})
        }).catch(error=>{
            dispatch({type: "USER_LOGIN_REJECTED", payload: error})
        })
    }
}

export function fetchCompanies(uid) {
    return dispatch => {
        dispatch({type: "GET_USER_COMPANIES"})
        db.collection(`userData/${uid}/empresas`).get().then(querySnapshot =>{

            let dataArray = []
            querySnapshot.forEach( doc => {
                dataArray.push(doc.data())
            })
            dispatch({type: "GET_USER_COMPANIES_FULFILLED", payload: dataArray})
            
        }).catch(error=>{
            dispatch({type: "GET_USER_COMPANIES_REJECTED", payload: error})
        })
    }
}

export function selectCompany(company, settings) {
    let currentSettings = settings.filter(x => {
        return x.value === company
         })[0].settings

    currentSettings['fim'] = currentSettings.fim.toDate()
    currentSettings['inicio'] = currentSettings.inicio.toDate()

    return dispatch =>{
        dispatch({type: "SELECT_COMPANY", payload:{company:company, settings:currentSettings }})
    }
}

export function updateSettings(settings) {
    return dispatch =>{
        dispatch({type: "UPDATE_USER_SETTINGS", payload:settings})
    }
}

export function uploadSettings(uid, empresa, settings) {
    let capitalize = string => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return dispatch =>{
        db.collection(`userData/${uid}/empresas/`).doc(empresa).set({settings:settings,value:empresa,label:capitalize(empresa)}).then(() => {
            dispatch({type: "UPLOAD_USER_SETTINGS"})
        }).catch(error => {
            dispatch({type: "UPLOAD_USER_SETTINGS_REJECTED", payload:error})
        })
    }
}

  
//   export function resetPassword (email) {
//     return firebaseAuth().sendPasswordResetEmail(email)
//   }





// WEBPACK FOOTER //
// ./src/actions/userActions.js